// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Login_mainContainer__1JcH2","main":"Login_main__1rVXi","formContainer":"Login_formContainer__3Xah4","form":"Login_form__3WuU-"};